import React, { Component, PropTypes } from 'react';
import PageLayoutStore from 'stores/PageLayout';
import { PageLayoutActions } from 'actions';
import { mixin, RefluxMixin } from 'Util';
import { getLayout } from 'selectors/pageLayout';
import PageLayout from 'components/Page/PageLayout';

class PageLayoutContainer extends mixin(RefluxMixin, Component) {
  static propTypes = {
    children: PropTypes.node,
    params: PropTypes.object,
    history: PropTypes.object
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  componentDidMount() {}

  listenToStores() {
    this.listenToStoreWithMapper(PageLayoutStore, state => {
      return {
        layout: getLayout(state),
        selectedPageModuleId: state.selectedPageModuleId,
        open: state.enabled,
        ...this.mapActions({
          closeLayoutEditor: PageLayoutActions.disable,
          openModuleMenu: PageLayoutActions.openModuleMenu
        })
      };
    });
  }

  render() {
    const { loading, open, ...other } = this.state;
    return (
      <PageLayout open={open} loading={loading} {...this.props} {...other} />
    );
  }
}

export default PageLayoutContainer;



// WEBPACK FOOTER //
// ./src/js/containers/PageLayoutContainer.js